<script setup lang="ts">
import type { UseLivekitAudioReturn } from '@/composables/livekit'

const props = defineProps<{
  audio: UseLivekitAudioReturn
}>()

const audioElements = computed<[string, HTMLAudioElement][]>(() => {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!props.audio.audioTracks.value) return []
  return Array.from(props.audio.audioTracks.value.entries())
})
</script>

<template>
  <div class="livekit-audio-container">
    <component v-for="[id, el] in audioElements" :key="id" :is="el" />
  </div>
</template>

<style scoped>
.livekit-audio-container {
  display: none;
}
</style>
